<template>
  <div>
    <tab-bar currentActive="settings" @changeActive="changeTabbar"></tab-bar>
    <div class="container-fluid">
      <div class="row pb-4 bg-blue2"
        style="background-image: url('/images/euros-fond-gris.png'); background-repeat: no-repeat;  background-position: center; padding-top: 100px;">
        <div class="col">
          <div>
            <!-- <img src="/images/loic-droite.png" alt=""
              style="width: 90px; height: 90px; object-fit: cover; border-radius: 50%; background-color: rgb(242, 195, 74)" /> -->
          </div>
          <h5 class="mt-3" style="text-transform: uppercase">
            <span class="font-weight-normal">BONJOUR</span> {{ this.$store.state.user.co_firstname }} {{
              this.$store.state.user.co_name }}
          </h5>
          <div class="topwhite">
            Vous avez planifié <strong>{{ patients_all.length }} patients</strong>
          </div>
        </div>
      </div>
      <div class="row mt-3" style="padding-bottom:150px;">
        <div class="col">
          <button class="btn btn-secondary buttonsettings" @click="gotoPerso">
            <strong>Préférences</strong><br />
            Gérez vos données par défaut
          </button>
          <!-- <button class="btn btn-secondary buttonsettings mt-3 d-flex justify-content-between align-items-center"
            @click="gotoDocs">
            <div>
              <strong>Techniques opératoires</strong><br />
              Téléchargez nos guides techniques
            </div>
            <div><img src="/images/ico-settings1.png" alt="" /></div>
          </button> -->
          <button class="btn btn-secondary buttonsettings mt-3 d-flex justify-content-between align-items-center"
            @click="gotoContact">
            <div>
              <strong>Contactez Euros</strong><br />
              Toutes nos coordonnées
            </div>
            <div><img src="/images/ico-settings2.png" alt="" /></div>
          </button>
          <button class="btn btn-secondary buttonsettings mt-3 d-flex justify-content-between align-items-center"
            @click="gotoShare">
            <div>
              <strong>Partager avec mes confrères</strong><br />
              Vous aimez Euros, faites-le savoir !
            </div>
            <div><img src="/images/ico-settings3.png" alt="" /></div>
          </button>
          <div class="mt-3"><a href="javascript:void(0);" @click="logout">Se déconnecter</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
import { version } from "../../package.json";

export default {
  name: "home-settings",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      version,
      patients_all: []
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    this.loadPatients();
    await this.$store.dispatch("setversion");
  },
  watch: {},
  computed: {},
  methods: {
    logout() {
      // this.$store.dispatch("logout");
      this.$router.push("/logout").catch(err => {});
    },
    gotoPerso() {
      this.$router.push("/settings/perso").catch(err => {});
    },
    gotoDocs() {
      this.$router.push("/settings/docs").catch(err => {});
    },
    gotoContact() {
      this.$router.push("/settings/contact").catch(err => {});
    },
    gotoShare() {
      this.$router.push("/settings/share").catch(err => {});
    },
    changeTabbar(where) {
      if (where == "patients") {
        this.showPassed = false;
      }
    },
    reloadApp() {
      window.location.reload();
    },

    async loadPatients() {
      let limit = 1000;
      let params = {
        // pa_archive: this.archive,
        // text: this.filterText,
        // sort: sort,
        limit: limit,
        // pa_type: "hanche"
      };
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients", { params });
      this.patients_all = response.data.data;
    }
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.cguwin {
  position: fixed;
  background-color: white;
  border: 1px solid black;
  top: 5%;
  height: 90%;
  width: 90%;
  left: 5%;
  z-index: 10001;
  padding: 20px;

  // overflow: auto;
  .btn-jaccepte {
    position: absolute;
    bottom: 5px;
  }
}

.cguwin-content {
  overflow: auto;
}

@media (min-width: 576px) {
  .helpwin {}
}

@media (min-width: 768px) {
  .helpwin {}
}

.h-100vh {
  height: 100vh;
}

.bg-blue2 {
  background-color: rgb(161, 173, 194);
}

.topwhite {
  background-color: white;
  border-radius: 20px;
  padding: 20px;
}

.buttonsettings {
  width: 100%;
  text-align: left;
  background-color: rgb(237, 236, 236);
  border-radius: 10px;
  color: rgb(12, 40, 56);
  padding: 20px;
}
</style>
